import qs from 'qs';
import axios from 'axios';

const responseInterceptors = {
  onFulfilled: (response) => {
    return response;
  },
  onRejected: (error) => {
    window.$nuxt.$sentry?.captureException(new Error(error));

    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    let defaultErrorMessage = null;

    if (error.response && error.response.status >= 500 && !error.response.data?.error?.message) {
      defaultErrorMessage = window.$nuxt.$t("error.internalServerError", {
        status: error.response.status
      });
    } else if (!error.response && !window.navigator.onLine) {
      defaultErrorMessage = window.$nuxt.$t("error.networkErrorOffline");
    } else if (!error.response) {
      defaultErrorMessage = window.$nuxt.$t("error.networkError");
    }

    if (defaultErrorMessage) {
      const objectError = {
        response: { data: { error: { message: defaultErrorMessage } } }
      };

      return Promise.reject(objectError);
    }

    return Promise.reject(error);
  }
};

const createAxiosInstance = ({ baseURL, useAccessToken = false, customHeaders = {}, addDefaultHeaders = true }) => {
  const defaultHeaders = {
    'Accept'       : 'application/json',
    'Content-Type' : 'application/json'
  };

  const headers = {
    ...(addDefaultHeaders ? defaultHeaders : {}),
    ...customHeaders
  };

  const instance = axios.create({
    baseURL,
    headers,
    paramsSerializer: params => qs.stringify(params, { skipNulls: true, skipEmptyString: true })
  });

  instance.interceptors.request.use(
    (config) => {
      const accessToken = window?.$nuxt?.$token?.get();
      if (useAccessToken && accessToken) {
        config.headers['Authorization'] = accessToken;
      }

      const language = window.$nuxt?.$store?.state?._core?.user?.languageId || 'pt-BR';
      config.headers['Accept-Language'] = language;

      const timezone = window.$nuxt?.$store?.state?._core?.user?.timezone || 'America/Sao_Paulo';
      config.headers['x-user-timezone'] = timezone;

      const query = window?.$nuxt?.$route?.query;
      if (config.passOnMobileHeaders && query['X-Client-Type'] && query['X-Device-Id']) {
        config.headers['X-Client-Type'] = query['X-Client-Type'];
        config.headers['X-Device-Id'] = query['X-Device-Id'];
      }

      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    responseInterceptors.onFulfilled,
    responseInterceptors.onRejected
  );

  return instance;
};

export {
  createAxiosInstance
};
